import { useEffect, useState } from "react";
import config  from "../config";
import getData from "../common/getData";
import { useKeycloak } from "@react-keycloak/web";
import useApiError from "./useApiError";

const usersURL = `${config.app.apiBaseUrl}chatbots/v1/ChatUsers/GetAll`;

function useGetUserId(userEmail){
    const [userId, setUserId] = useState([]);
    const { keycloak } = useKeycloak();
    const { addError } = useApiError();

    useEffect(
        function () {
            async function init() {
                if (!keycloak?.token) return;                
                if(!userEmail) return;

                let bearerToken = keycloak.token;
                try {
                    let users = await getData(bearerToken, usersURL, "json", true);
                    let singleUser = users.find((u) => u.email === userEmail)?.id;
                    if (singleUser) {
                        setUserId(singleUser);
                    }
                } catch (err){
                    addError(`LOAD_DATA_ERROR: ${err}`, err);
                }
            }
            init();
        },
        // eslint-disable-next-line
        [userEmail, keycloak?.token]
    );
    return userId;
}

export default useGetUserId;